import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-window-close',
  template: '',
  standalone: true
})
export class WindowCloseComponent implements OnInit {
  ngOnInit() {
    console.log('WindowClose');
    window.close();
  }
}
